export function gtag () {
  if (typeof window.gtag === 'function') {
    window.gtag(...arguments)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/gtag.js